import adminAxios from '../utils/adminAxios';
import {
  ADMIN_LOADED, ADMIN_AUTH_ERROR, ADMIN_LOGIN_SUCCESS,
  ADMIN_LOGIN_FAIL, ADMIN_LOGOUT
} from './types';

// Carga el admin a partir del token guardado (valida la sesión).
export const loadAdmin = () => async dispatch => {
  if (!localStorage.getItem('adminToken')) {
    return dispatch({ type: ADMIN_AUTH_ERROR });
  }
  try {
    const res = await adminAxios.get('/api/auth/admin');
    dispatch({ type: ADMIN_LOADED, payload: res.data });
  } catch (err) {
    dispatch({ type: ADMIN_AUTH_ERROR });
  }
};

// Login de administrador contra /api/auth/admin.
export const loginAdmin = (email, password) => async dispatch => {
  try {
    const res = await adminAxios.post('/api/auth/admin', { email, password });
    dispatch({ type: ADMIN_LOGIN_SUCCESS, payload: res.data });
    await dispatch(loadAdmin());
  } catch (err) {
    const errors = err.response?.data?.errors || [{ msg: 'Error de autenticación' }];
    dispatch({ type: ADMIN_LOGIN_FAIL, payload: errors });
  }
};

export const logoutAdmin = () => dispatch => {
  dispatch({ type: ADMIN_LOGOUT });
};
